import { Container } from "@chakra-ui/react";
import Head from "next/head";
import { useEffect } from "react";

export default function PageProtector({ children, isActive = true }) {
  const protect = () => {
    document.oncontextmenu = (evt) => {
      evt.preventDefault();
    };
    document.oncopy = (evt) => {
      evt.clipboardData.setData(
        "text/plain",
        "To prevent plagiarism, we've disabled copy and paste functionality on AdmitYogi. We're sorry for the inconvenience!",
      );
      evt.preventDefault();
    };
    document.onmousedown = (evt) => {
      if (evt.button == 2) evt.preventDefault();
    };
    document.onselectstart = (_) => false;
    document.onselectchange = (_) => false;
    const css = document.body.style;
    css.userSelect = "none";
    css.webkitUserSelect = "none";
  };
  const cleanup = () => {
    document.oncontextmenu = undefined;
    document.oncopy = undefined;
    document.onmousedown = undefined;
    document.onselectstart = undefined;
    document.onselectchange = undefined;
    const css = document.body.style;
    css.userSelect = "inherit";
    css.webkitUserSelect = "inherit";
  };

  useEffect(() => cleanup, []);
  useEffect(() => {
    if (isActive) protect();
    else cleanup();
  }, [isActive]);

  if (!isActive) {
    return children;
  } else {
    return (
      <>
        <Head>
          <style>
            {`*{user-select:none;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;}*::selection{background:none;}*::-moz-selection{background:none;}@media print{#noprint{display:none;}}@media screen{#print{display:none;}}`}
          </style>
        </Head>
        <Container id="print">
          To prevent plagiarism, we&apos;ve disabled printing on AdmitYogi. We&apos;re sorry for the
          inconvenience!
        </Container>
        <div id="noprint">{children}</div>
      </>
    );
  }
}
